/**
 * Toggle attribute
 * @param {Array<HTMLElement>} targets
 * @param {String} name
 * @param {String} values
 */
const attributeToggle = (targets, name, values) => {
  values = values.toString();

  for (const target of targets) {
    /** Initialize the current values from the attribute, or an empty array if not present */
    const currentValues = (target.getAttribute(name) || "")
      .split(" ")
      .filter(Boolean);

    /** Toggle the provided value in the array */
    const updatedValues = currentValues.includes(values)
      ? currentValues.filter((val) => val !== values)
      : [...currentValues, values];

    /** Set the updated value back to the attribute */
    const newAttrValue = updatedValues.join(" ").trim();
    target.setAttribute(name, newAttrValue);
  };
};

export default attributeToggle;
